import React, { useState } from "react";


function validateInput (name, value) {
    let message = '';
    switch (name) {
        case 'full-name':
            if (value.length < 6 || value.trim() === ''){
                message = "Будь-ласка, введіть коректне ім'я";
            }
            break;
        case 'phone':
            if (!/^\d*$/.test(value)) {
                message = "Будь-ласка, введіть коректний номер телефону";
            } else if (value.length !== 9) {
                message = "Будь-ласка, введіть 9 цифр";
            }
            break;
        case 'address':
            if (value.trim() === '') {
                message = "Будь-ласка, заповніть адресу";
            }
            break;
        default:
            break;
    }
    return message;
}

export const CheckoutForm = ({children, onCheckoutForm}) => {

    const [errors, setErrors] = useState({});

    const handleInputChange = (data) => {
        const { name, value } = data;
        const warning = validateInput(name, value);
        setErrors(errors => ({ ...errors, [name]: warning }));
    }

    const handleInputBlur = (data) => {
        const { name, value } = data;
        const warning = validateInput(name, value);
        setErrors(errors => ({ ...errors, [name]: warning }));
    }

    const handleSubmit = (e) => {
        e.preventDefault();

        let formValid = true;

        const formData = new FormData(e.target);

        let newErrors = { ...errors };

        for (const item of formData) {
            const error = validateInput(item[0], item[1]);

            newErrors[item[0]] = error;

            if (error) {
                formValid = false;
            }
        }
        setErrors(newErrors);

        if (formValid) {
            onCheckoutForm(formValid)

            localStorage.setItem('shipping', JSON.stringify({
                    'full-name': formData.get('full-name'),
                    'phone': `0${formData.get('phone')}`,
                    'address': formData.get('address'),
                    'comment': formData.get('comment'),
                }))
            localStorage.setItem('payment', formData.get('pay-methods'))
        }
    }

    const childrenWithProps = React.Children.map(children, child => {
        if (React.isValidElement(child)) {
            return React.cloneElement(child, {onInputChange: handleInputChange, onInputBlur: handleInputBlur, onError: errors})
        }
        return child
    })

    return (
        <form className="shipping-form" onSubmit={(e) => handleSubmit(e)}>
            {childrenWithProps} 
            <input type="submit" value="Замовити" className="order-submit"/>
        </form>
    )
}